import { ReduxAction } from './helper';

export const setTrackingVessels = new ReduxAction("TRACKING_VESSELS_SET", vessels => vessels);
export const setFilterByFleetName = new ReduxAction("TRACKING_VESSELS_FILTER_BY_NAME", name => name);
export const setHighlightedImo = new ReduxAction("TRACKING_VESSELS_HIGHLIGHTED_SET", imo => imo);